import { render, staticRenderFns } from "./law-guide.vue?vue&type=template&id=33c2b968&scoped=true&"
import script from "./law-guide.vue?vue&type=script&lang=js&"
export * from "./law-guide.vue?vue&type=script&lang=js&"
import style0 from "./law-guide.vue?vue&type=style&index=0&id=33c2b968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2b968",
  null
  
)

export default component.exports